import styles from './Textarea.module.scss';

interface TextareaProps {
  label: string;
  value?: string;
  placeholder?: string;
  readOnly: boolean;
  rows?: number;
}

export const Textarea = ({ label, value, placeholder, readOnly, rows = 4 }: TextareaProps) => {
  return (
    <div className={styles['textarea']}>
      <label className={styles['label']}>{label}</label>
      <textarea
        className={styles['form']}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        rows={rows}
      />
    </div>
  );
};
